
export var DAYS_OF_WEEK = [ "sun", "mon", "tue", "wed", "thu", "fri", "sat" ];

export var DEFAULT_TERRITORY = '001';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/cldr/constants.js
// module id = 813
// module chunks = 30